module.exports = __webpack_public_path__ + "img/service-255.79d65fe7.png";